// Development logging utility for auth diagnostics
export const DEV_AUTH_DEBUG = import.meta?.env?.VITE_DEBUG_AUTH === 'true';

export function dlog(tag: string, ...args: any[]) {
  if (!DEV_AUTH_DEBUG) return;
  const ts = new Date().toISOString().split('T')[1].replace('Z','');
  // eslint-disable-next-line no-console
  console.debug(`[${ts}] ${tag}`, ...args);
}